import { defineStore } from "pinia";
import { markRaw } from "vue";

export const useDetailviewStore = defineStore("detailview", {
  state: () => ({
    component: null,

    visible: false,
    title: "",
    mode: "",
    context: "" as string,
    selectedItem: null as any,
    actions: null as any,

    loading: false,
    loadingSave: false,
    saveBarVisible: false,
    saveBarError: false,
    saveBarErrorText: "",
    // Optionale Folgeaktion im Fehlerband: Manche Fehler sind aufloesbar
    // (Bugreport 14.09.26: "Konto ist archiviert" -> uebernehmen), statt den
    // Nutzer in einer Sackgasse stehen zu lassen.
    saveBarErrorAction: null as null | { label: string; handler: () => any },
    saveBarErrorActionLoading: false,

    onLoad: null as null | (() => Promise<any> | any),
    onSave: null as null | (() => Promise<any> | any),
    onCreate: null as null | (() => Promise<any> | any),
    onUndo: null as null | (() => Promise<any> | any),
    hasUnsavedChanges: () => false,
    loadToken: 0,

    onSaved: null as null | (() => Promise<any> | any),
    // Erhaelt optional Kennung und Nutzdaten des angelegten Datensatzes.
    onCreated: null as null | ((...args: any[]) => Promise<any> | any),

    // Resolves false, wenn der Benutzer die Aktion im Dialog abbricht
    // ("Fortsetzen"); true/undefined = fortfahren.
    performGuardedAction: (async (fn: () => void) => {
      fn();
      return true;
    }) as (fn: () => void) => Promise<boolean | void>,
  }),

  actions: {
    open(props: any = {}) {
      this.component = props.component ? markRaw(props.component) : null;

      this.visible = true;
      this.title = props.title ?? "";
      this.mode = props.mode ?? "";
      this.context = props.context ?? "";
      this.selectedItem = props.selectedItem ?? null;
      this.actions = props.actions ?? null;

      this.loading = props.loading ?? false;
      this.loadingSave = false;

      this.saveBarVisible = false;
      this.saveBarError = false;
      this.saveBarErrorText = "";
      this.saveBarErrorAction = null;
      this.saveBarErrorActionLoading = false;

      this.onSaved = props.onSaved ?? null;
      this.onCreated = props.onCreated ?? null;
    },

    close() {
      this.component = null;

      this.visible = false;
      this.title = "";
      this.mode = "";
      this.context = "";
      this.selectedItem = null;
      this.actions = null;

      this.loading = false;
      this.loadingSave = false;

      this.saveBarVisible = false;
      this.saveBarError = false;
      this.saveBarErrorText = "";
      this.saveBarErrorAction = null;
      this.saveBarErrorActionLoading = false;
    },

    setError(msg: string, action: null | { label: string; handler: () => any } = null) {
      this.saveBarError = true;
      this.saveBarErrorText = msg;
      this.saveBarErrorAction = action;
      this.saveBarErrorActionLoading = false;
    },

    clearError() {
      this.saveBarError = false;
      this.saveBarErrorText = "";
      this.saveBarErrorAction = null;
      this.saveBarErrorActionLoading = false;
    },
  },
});
